export default "__VITE_ASSET__20b8687f__"